export const siteInfo = {
  name: "ItaoBuy Spreadsheet Italia",
  url: "https://itaobuyspread.rest",
  description: "La piattaforma di riferimento in Italia per guide, template e strumenti dedicati a ItaoBuy Spreadsheet. Organizza prodotti, prezzi e ordini con efficienza professionale.",
  logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
  sameAs: ["https://kaspreadsheet.com"],
};

export interface ArticleMeta {
  slug: string;
  headline: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
  faqs?: { question: string; answer: string }[];
}

export const articlesMeta: ArticleMeta[] = [
  {
    slug: "/articoli/guida-completa-itaobuy-spreadsheet",
    headline: "Guida Definitiva a ItaoBuy Spreadsheet: Organizza Prodotti, Prezzi e Ordini Come un Professionista",
    description: "Guida completa su ItaoBuy Spreadsheet: dalle nozioni di base alla configurazione avanzata, strategie di gestione prodotti, analisi prezzi, monitoraggio ordini e tecniche di ottimizzazione.",
    image: "https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20large%20monitor%20displaying%20spreadsheet%20data%20and%20product%20catalog%2C%20surrounded%20by%20fashion%20items%20shoes%20bags%20accessories%20neatly%20arranged%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%20from%20window%2C%20minimalist%20modern%20office%2C%20clean%20editorial%20photography%20style%2C%20professional%20atmosphere&width=1200&height=600&seq=article-hero-18&orientation=landscape",
    datePublished: "2026-06-01",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
    faqs: [
      { question: "ItaoBuy Spreadsheet è gratuito?", answer: "Sì, ItaoBuy Spreadsheet è completamente gratuito. Puoi utilizzare Google Sheets o qualsiasi altro software di fogli di calcolo per implementare il sistema senza alcun costo aggiuntivo." },
      { question: "Posso usare ItaoBuy Spreadsheet su dispositivi mobili?", answer: "Assolutamente sì. Utilizzando Google Sheets, il tuo ItaoBuy Spreadsheet è accessibile da smartphone e tablet tramite l'app Google Sheets, disponibile sia per iOS che Android." },
      { question: "Quanti prodotti posso gestire con ItaoBuy Spreadsheet?", answer: "Non c'è un limite fisso. Google Sheets supporta fino a 10 milioni di celle, quindi puoi gestire migliaia di prodotti senza problemi." },
    ],
  },
  {
    slug: "/articoli/template-itaobuy-spreadsheet",
    headline: "Template ItaoBuy Spreadsheet: Modelli Gratuiti per Gestire Prodotti e Ordini",
    description: "Guida completa sui template ItaoBuy Spreadsheet: modelli Excel e Google Sheets pronti all'uso, consigli di personalizzazione e strategie per adattare ogni foglio di calcolo alle tue esigenze.",
    image: "https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20large%20monitor%20displaying%20beautiful%20spreadsheet%20template%20designs%20in%20warm%20neutral%20colors%2C%20surrounded%20by%20notebooks%20and%20a%20coffee%20cup%2C%20soft%20natural%20light%20from%20window%2C%20professional%20workspace%20photography%2C%20inviting%20and%20organized%20composition&width=1200&height=600&seq=article-template-hero-v2&orientation=landscape",
    datePublished: "2026-06-05",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
    faqs: [
      { question: "I template ItaoBuy Spreadsheet sono davvero gratuiti?", answer: "Sì, tutti i template ItaoBuy Spreadsheet sono completamente gratuiti. Li mettiamo a disposizione della community per aiutare chiunque a organizzare meglio i propri acquisti." },
      { question: "Posso usare i template su Excel e Google Sheets?", answer: "Assolutamente sì. Ogni template ItaoBuy Spreadsheet è disponibile in formato compatibile sia con Microsoft Excel che con Google Sheets." },
    ],
  },
  {
    slug: "/articoli/tracciamento-prezzi-itaobuy",
    headline: "Tracciamento Prezzi con ItaoBuy Spreadsheet: La Guida Definitiva",
    description: "Impara a monitorare le fluttuazioni di prezzo, impostare alert automatici e identificare il momento migliore per acquistare con ItaoBuy Spreadsheet.",
    image: "https://readdy.ai/api/search-image?query=Modern%20financial%20dashboard%20displayed%20on%20a%20large%20monitor%20showing%20price%20trend%20charts%20and%20analytics%20graphs%2C%20warm%20cream%20desk%20with%20minimal%20accessories%2C%20soft%20natural%20window%20lighting%2C%20professional%20data%20analysis%20workspace%20photography%2C%20clean%20elegant%20composition&width=1200&height=600&seq=article-prezzi-hero-v2&orientation=landscape",
    datePublished: "2026-06-10",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
    faqs: [
      { question: "Con che frequenza devo aggiornare i prezzi?", answer: "Per prodotti molto richiesti, consigliamo un aggiornamento settimanale. Per articoli meno volatili, un controllo mensile è sufficiente." },
      { question: "Posso tracciare prezzi da qualsiasi sito?", answer: "Sì, il sistema di tracciamento prezzi ItaoBuy funziona con qualsiasi sito web. Basta inserire manualmente il prezzo e la data." },
    ],
  },
  {
    slug: "/articoli/gestione-ordini-itaobuy",
    headline: "Gestione Ordini con ItaoBuy Spreadsheet: Dal Checkout alla Consegna",
    description: "Scopri come ItaoBuy Spreadsheet trasforma la gestione ordini in un processo fluido e organizzato. Monitora ogni acquisto dalla conferma fino alla consegna.",
    image: "https://readdy.ai/api/search-image?query=Modern%20organized%20desk%20with%20laptop%20displaying%20order%20tracking%20dashboard%2C%20shipping%20labels%20and%20packing%20materials%20neatly%20arranged%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20logistics%20management%20workspace%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-ordini-hero-v2&orientation=landscape",
    datePublished: "2026-06-12",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
    faqs: [
      { question: "Quanti ordini posso gestire contemporaneamente?", answer: "Con ItaoBuy Spreadsheet non ci sono limiti pratici. Puoi gestire da pochi ordini a centinaia senza problemi di performance." },
      { question: "Posso integrare notifiche automatiche?", answer: "Sì, con Google Apps Script puoi impostare email automatiche quando un ordine cambia stato o quando la data di consegna si avvicina." },
    ],
  },
  {
    slug: "/articoli/confronto-strumenti-itaobuy",
    headline: "ItaoBuy Spreadsheet vs Altri Strumenti: Il Confronto Definitivo",
    description: "ItaoBuy Spreadsheet, Excel tradizionale, Google Sheets base o app gestionali: analizziamo pro e contro di ogni opzione per aiutarti a scegliere con consapevolezza.",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20two%20laptops%20side%20by%20side%20showing%20different%20spreadsheet%20interfaces%20for%20comparison%2C%20warm%20cream%20desk%20setting%2C%20soft%20natural%20lighting%2C%20professional%20tech%20review%20photography%2C%20clean%20balanced%20composition%20with%20subtle%20shadows&width=1200&height=600&seq=article-confronto-hero-v2&orientation=landscape",
    datePublished: "2026-06-15",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/guida-acquisti-itaobuy",
    headline: "Guida Completa agli Acquisti Intelligenti con ItaoBuy Spreadsheet",
    description: "Impara le migliori strategie di shopping online con ItaoBuy Spreadsheet. Dalla ricerca prodotti alla negoziazione del prezzo, passando per il confronto tra venditori.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20shopping%20concept%20with%20a%20tablet%20showing%20online%20store%20next%20to%20fashion%20items%20and%20accessories%20on%20a%20cream%20surface%2C%20warm%20natural%20lighting%2C%20lifestyle%20photography%2C%20sophisticated%20minimalist%20composition%2C%20soft%20shadows%20and%20refined%20aesthetic&width=1200&height=600&seq=article-acquisti-hero-v2&orientation=landscape",
    datePublished: "2026-06-18",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/database-prodotti-itaobuy",
    headline: "Come Creare un Database Prodotti Completo con ItaoBuy Spreadsheet",
    description: "Costruisci un catalogo prodotti professionale con ItaoBuy Spreadsheet. Scopri le migliori tecniche di categorizzazione, gestione SKU, tagging e organizzazione delle varianti.",
    image: "https://readdy.ai/api/search-image?query=Modern%20organized%20workspace%20with%20large%20monitor%20displaying%20structured%20product%20database%20with%20thumbnail%20images%20and%20categories%2C%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20professional%20catalog%20management%20photography%2C%20clean%20systematic%20composition&width=1200&height=600&seq=article-database-hero-v2&orientation=landscape",
    datePublished: "2026-06-20",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/principianti-itaobuy-spreadsheet",
    headline: "ItaoBuy Spreadsheet per Principianti: La Guida per Iniziare da Zero",
    description: "Non hai mai usato un foglio di calcolo per gestire acquisti? Nessun problema. Questa guida ItaoBuy per principianti ti accompagna passo dopo passo nella configurazione del tuo primo foglio.",
    image: "https://readdy.ai/api/search-image?query=Simple%20clean%20beginner%20workspace%20with%20an%20open%20notebook%20and%20laptop%20showing%20basic%20spreadsheet%20tutorial%2C%20warm%20cream%20background%2C%20encouraging%20soft%20natural%20light%2C%20welcoming%20learning%20environment%2C%20friendly%20minimalist%20photography%2C%20comfortable%20setup&width=1200&height=600&seq=article-principianti-hero-v2&orientation=landscape",
    datePublished: "2026-06-22",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/automazione-itaobuy-spreadsheet",
    headline: "Automazione Avanzata con ItaoBuy Spreadsheet e Google Apps Script",
    description: "Scopri come automatizzare il tuo ItaoBuy Spreadsheet con Google Apps Script. Dall'importazione automatica dei dati alle notifiche email, trasforma il tuo foglio in uno strumento intelligente.",
    image: "https://readdy.ai/api/search-image?query=Modern%20developer%20workspace%20with%20clean%20code%20visible%20on%20ultrawide%20monitor%20showing%20Google%20Apps%20Script%20editor%20interface%2C%20minimal%20desk%20accessories%20in%20warm%20cream%20tones%2C%20soft%20natural%20lighting%2C%20professional%20programming%20environment%20photography%2C%20elegant%20composition&width=1200&height=600&seq=article-automation-hero&orientation=landscape",
    datePublished: "2026-06-25",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/sicurezza-itaobuy-spreadsheet",
    headline: "Sicurezza e Privacy nel Tuo ItaoBuy Spreadsheet",
    description: "Proteggi i tuoi dati sensibili con le migliori pratiche di sicurezza per ItaoBuy Spreadsheet. Crittografia, permessi di accesso, autenticazione a due fattori e strategie di backup.",
    image: "https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20workspace%20with%20laptop%20displaying%20data%20protection%20dashboard%2C%20shield%20icons%20and%20lock%20symbols%20on%20screen%2C%20warm%20cream%20desk%20setup%2C%20soft%20natural%20lighting%2C%20professional%20data%20security%20photography%2C%20clean%20professional%20composition&width=1200&height=600&seq=article-security-hero&orientation=landscape",
    datePublished: "2026-06-28",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/collaborazione-itaobuy",
    headline: "Collaborazione in Team con ItaoBuy Spreadsheet su Google Sheets",
    description: "Scopri come utilizzare ItaoBuy Spreadsheet in modalità collaborativa. Condivisione in tempo reale, commenti, cronologia versioni e gestione dei permessi per team di acquisti.",
    image: "https://readdy.ai/api/search-image?query=Modern%20collaborative%20office%20workspace%20with%20multiple%20laptops%20showing%20shared%20spreadsheet%20on%20screens%2C%20team%20members%20working%20together%20at%20a%20warm%20cream%20colored%20desk%2C%20soft%20natural%20lighting%2C%20professional%20teamwork%20photography%2C%20clean%20harmonious%20composition&width=1200&height=600&seq=article-collab-hero&orientation=landscape",
    datePublished: "2026-07-01",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
  {
    slug: "/articoli/ottimizzazione-itaobuy",
    headline: "10 Trucchi per Ottimizzare il Tuo ItaoBuy Spreadsheet",
    description: "Scopri i segreti degli utenti esperti: scorciatoie, formule nascoste, formattazione condizionale e trucchi di produttività per sfruttare al massimo il tuo ItaoBuy Spreadsheet.",
    image: "https://readdy.ai/api/search-image?query=Modern%20ultra%20productive%20workspace%20with%20laptop%20displaying%20colorful%20spreadsheet%20with%20conditional%20formatting%20and%20advanced%20formulas%2C%20keyboard%20shortcuts%20overlay%20visible%2C%20minimal%20warm%20cream%20desk%20setup%2C%20soft%20natural%20lighting%2C%20professional%20productivity%20photography%2C%20clean%20inspiring%20composition&width=1200&height=600&seq=article-tips-hero&orientation=landscape",
    datePublished: "2026-07-05",
    dateModified: "2026-07-14",
    authorName: "ItaoBuy Editorial Team",
  },
];

export function buildArticleJsonLd(article: ArticleMeta): Record<string, unknown> {
  const graph: Record<string, unknown>[] = [
    {
      "@type": "BlogPosting",
      "@id": `${siteInfo.url}${article.slug}#article`,
      headline: article.headline,
      description: article.description,
      image: article.image,
      datePublished: article.datePublished,
      dateModified: article.dateModified,
      author: {
        "@type": "Organization",
        name: article.authorName,
        url: siteInfo.url,
      },
      publisher: {
        "@type": "Organization",
        name: siteInfo.name,
        logo: {
          "@type": "ImageObject",
          url: siteInfo.logo,
        },
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": `${siteInfo.url}${article.slug}`,
      },
      isPartOf: {
        "@type": "Blog",
        name: `${siteInfo.name} Blog`,
        url: siteInfo.url,
      },
    },
  ];

  if (article.faqs && article.faqs.length > 0) {
    graph.push({
      "@type": "FAQPage",
      "@id": `${siteInfo.url}${article.slug}#faq`,
      mainEntity: article.faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    });
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}

export function buildHomeJsonLd(): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${siteInfo.url}#website`,
        url: siteInfo.url,
        name: siteInfo.name,
        description: siteInfo.description,
        inLanguage: "it",
        publisher: {
          "@type": "Organization",
          "@id": `${siteInfo.url}#organization`,
          name: siteInfo.name,
        },
      },
      {
        "@type": "Organization",
        "@id": `${siteInfo.url}#organization`,
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        logo: {
          "@type": "ImageObject",
          url: siteInfo.logo,
        },
        sameAs: siteInfo.sameAs,
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${siteInfo.url}#breadcrumb`,
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: siteInfo.url,
          },
        ],
      },
    ],
  };
}